/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401,
  PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500,
} from "../../types/pecegePayCreditCardController/PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund.ts";

function getPatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundUrl(
  courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/pecegepay/creditcard/${courseFinPersonPaymentId}/refund` as const,
  };
  return res;
}

/**
 * @description Registra um pedido de estorno de pagamento com cartão de crédito.
 * @summary Registrar estorno de cartão de crédito
 * {@link /api/v1/pecegepay/creditcard/:courseFinPersonPaymentId/refund}
 */
export async function patchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund(
  courseFinPersonPaymentId: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundPathParams["courseFinPersonPaymentId"],
  params?: PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund400
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund401
      | PatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefund500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1PecegepayCreditcardCoursefinpersonpaymentidRefundUrl(
      courseFinPersonPaymentId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
